/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchreadyitemphotos3Inputs */

const en_searchreadyitemphotos3 = /** @type {(inputs: Searchreadyitemphotos3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At least 3 photos`)
};

const de_searchreadyitemphotos3 = /** @type {(inputs: Searchreadyitemphotos3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestens 3 Fotos`)
};

/**
* | output |
* | --- |
* | "At least 3 photos" |
*
* @param {Searchreadyitemphotos3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchreadyitemphotos3 = /** @type {((inputs?: Searchreadyitemphotos3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchreadyitemphotos3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchreadyitemphotos3(inputs)
	return de_searchreadyitemphotos3(inputs)
});
export { searchreadyitemphotos3 as "searchReadyItemPhotos" }